<nav #navbar class="navbar navbar-expand-lg navbar-transparent  navbar-absolute">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <a *ngIf="getBackOption()" class="navbar-brand navbar-focus-change" style="margin-right: 0; cursor: pointer;"
        (click)="voltar()">Voltarㅤ</a>
      <a class="navbar-brand" style="margin-left: 0;">|ㅤ {{getTitle()}}</a>
    </div>
    <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end">
      <!--form class="navbar-form">
        <div class="input-group no-border">
          <input type="text" class="form-control" placeholder="Pesquisar..." [(ngModel)]="query"
            (input)="onInputChange()" />
          <ul class="command-list" *ngIf="filtered.length > 0">
            <li *ngFor="let cmd of filtered" (click)="navigate(cmd.path)">
              {{ cmd.name }}
            </li>
          </ul>
        </div>
      </form-->
      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a class="nav-link" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            <i class="material-icons" style="cursor: pointer;">notifications</i>
            <span class="notification">{{ notificationsQuantity }}</span>
            <p>
              <span class="d-lg-none d-md-block">Notificações</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right scrollTrue" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" style="cursor: pointer;" (click)="goToDashboard(notification.report_id)"
              *ngFor="let notification of notifications">
              Há recomendações pendentes no estudo {{ notification.title }} do cliente {{ notification.client}} há {{
              notification.days }} {{ notification.days === 1 ? 'dia' : 'dias' }}.
            </a>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#/user">
            <i class="material-icons">person</i>
            <p>
              <span class="d-lg-none d-md-block">Perfil</span>
            </p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>